// /**
//  * @see https://umijs.org/docs/max/access#access
//  * */
// export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
//   const { currentUser } = initialState ?? {};
//   return {
//     canAdmin: currentUser && currentUser.access === 'admin',
//   };
// }


/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState) {
  const { currentUser } = initialState || {};
  let role = null;
  let access = null;
  if (currentUser && currentUser.role === 99) {          
    role = 'superAdmin';
  } else if (currentUser && currentUser.role === 1) {
    role = 'admin';
  } else if (currentUser && currentUser.role === 10) {
    role = 'taskAdmin';
  } else {
    role = 'user';
  }
  return {    
    onlyUser:currentUser && role && role === 'user',
    superAdmin: currentUser && role && role === 'superAdmin',
    adminAndUser:currentUser && role && (role === 'admin' || role === 'user'),
    adminAndSuperAdmin: role && role && (role === 'admin' || role === 'superAdmin'),
    admin:currentUser && role && role === 'admin',
    taskAdmin:currentUser && role && role === 'taskAdmin',
    adminAndTaskAdmin:currentUser && role &&  (role === 'admin' || role === 'taskAdmin'),
    user:currentUser && role && (role === 'user' || role === 'taskAdmin'),
  };
}
